import Index from '@tunnel-components/@sharded/@widgets/filtre-multiple/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/filtre-multiple/index.ts